import Repository from './Repository'

import axios from 'axios'

const baseURL = 'https://api.poder.io/api/v1'

const data = { 'email': 'info@farmatodo.com', 'password': 'far@#$_todo', 'withCredentials': true }



const RepositoryEpica = axios.create({ baseURL })

const endpoint = 'users'

// const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo0NCwic2NoZW1hIjoiZmFybWF0b2RvIiwiZXhwIjoxNTc5ODc4MDcxfQ.x1HgknK-Qc_GYXXcejPr6BBvl6Fn7-OcQpPjZ0_e9FA'

//const header = `Authorization: ${token}`

// localStorage.setItem('tp', token)

// axios.defaults.withCredentials = true

export default {
    getProfiles() {
        return Repository.get(`cms/getClusteres`)
    },
    insertProfiles(payload) {
        return Repository.post(`cms/insertCluster`, payload)
    },

    updateOrderBanner(payload) {
        // {
        //   "idCluster":2171,
        //   "listBanner":[112,111,61,85]
        // }

        return Repository.post(`cms/updateOrderBanner`, payload)
    },

    deleteCluster(idCluster) {
        return Repository.post(`cms/deleteCluster`, { idCluster: idCluster })
    },

    updateProfile(payload) {
        return Repository.post(`cms/editCluster`, payload)
    },
    getClusters() {

        return Repository.get(`cms/getClusteresPoderIO`)
            //return RepositoryEpica.get(`clusters`)
    },
    auth() {
        return Repository.get(`cms/generateToken`)
    },
}